import { useState } from "react";
import { useDocument } from "./useDocument";

export function useRazorpay() {
  const { document: razorpayKeyDocument } = useDocument(
    "settings",
    "paymentMethod"
  );
  const { document: colorsDoc } = useDocument("settings", "Colors");

  const { document: organisationDoc } = useDocument("settings", "organisation");

  const { document: currencyDoc } = useDocument("settings", "currency");

  const [paymentResponse, setPaymentResponse] = useState({
    transactionID: "",
    paymentStatus: "Pending",
    paymentDetails: null,
  });

  const razorpayKeyId = razorpayKeyDocument?.razorpay?.payment_key;

  // const razorpayTestId = process.env.REACT_APP_RAZORPAY_KEY_ID;

  async function makePayment(
    orderId,
    amount,
    name,
    description,
    email,
    contact
  ) {
    try {
      const razorpayOptions = {
        key: razorpayKeyId, // Replace with your key
        amount: amount * 100, // amount in paise
        currency: currencyDoc?.code,
        name: organisationDoc?.full_name,
        description: organisationDoc?.short_details,
        handler: async function (response) {
          console.log("Payment success:", response);
          setPaymentResponse({
            transactionID: response.razorpay_payment_id,
            paymentStatus: "Success",
            paymentDetails: {
              amount: amount,
              currency: currencyDoc?.code,
              timestamp: new Date().toISOString(),
            },
          });
        },
        modal: {
          ondismiss: function () {
            console.log("Payment dismissed");

            setPaymentResponse({
              transactionID: "",
              paymentStatus: "Cancelled",
              paymentDetails: null,
              paymentMethodType: "",
            });
          },
        },
        prefill: {
          name: name,
          email: email,
          contact: contact,
        },
        notes: {
          orderId: orderId,
        },
        theme: {
          color: colorsDoc?.LightScreenTheme?.logoPrimaryColor || "#000000", // fallback color
        },
      };

      const rzp1 = new window.Razorpay(razorpayOptions);

      // ✅ Catch payment failure properly
      rzp1.on("payment.failed", function (response) {
        console.error("Payment failed:", response);

        setPaymentResponse({
          transactionID: response.error.metadata.payment_id || null,
          paymentStatus: "Failed",
          paymentDetails: {
            reason: response.error.reason,
            description: response.error.description,
            code: response.error.code,
            timestamp: new Date().toISOString(),
          },
        });
      });

      rzp1.open();
    } catch (error) {
      console.error("Error in makePayment:", error);
      setPaymentResponse({
        transactionID: "",
        paymentStatus: "Failed",
        paymentDetails: {
          error: error.message,
          timestamp: new Date().toISOString(),
        },
      });
    }
  }

  return { makePayment, paymentResponse };
}
